/**
 * Leistungen des Betriebs.
 *
 * Ersetzt die zehn Bereichstypen der ersten Fassung. Eine Position trägt
 * genau eine Leistung – das ist die Angabe, die im Angebot als Titel steht.
 *
 * Erweitern: einen Eintrag ergänzen. Oberfläche und Datenbank ändern sich
 * nicht, das Feld ist ein freier Text mit geprüfter Werteliste.
 */
export const LEISTUNGEN = ['maler', 'tapezieren', 'lackieren', 'fassade', 'putz', 'sonstiges'];
export const LEISTUNG_LABELS = {
    maler: 'Malerarbeiten',
    tapezieren: 'Tapezieren',
    lackieren: 'Lackierarbeiten',
    fassade: 'Fassade',
    putz: 'Putzarbeiten',
    sonstiges: 'Sonstiges',
};
export function leistungLabel(leistung) {
    return LEISTUNG_LABELS[leistung] ?? 'Sonstiges';
}
/**
 * Abbildung der alten Bereichstypen auf Leistungen.
 *
 * Wird von der Datenmigration verwendet und ist hier dokumentiert, damit die
 * Zuordnung nachlesbar bleibt. Der ursprüngliche Typ geht nicht verloren – er
 * landet im Feld `herkunft` der Position.
 */
export const BEREICHSTYP_ZU_LEISTUNG = {
    maler_tapezier: 'maler',
    kreativtechnik: 'maler',
    lackierarbeiten: 'lackieren',
    innenputz: 'putz',
    fassadengestaltung: 'fassade',
    fassadenbeschriftung: 'fassade',
    waermedaemmung: 'fassade',
    schimmelsanierung: 'sonstiges',
    dachsanierung: 'sonstiges',
    sonstiges: 'sonstiges',
};
//# sourceMappingURL=leistungen.js.map